import React, { Children, cloneElement, isValidElement } from 'react'

import { DashboardMenuItem } from './DashboardMenuItem'
import * as S from './styled'
import type { DashboardMenuProps } from './types'

export const DashboardMenu = ({ children }: DashboardMenuProps) => (
  <S.Container>
    {Children.map(children, (child) => {
      if (isValidElement(child)) {
        return cloneElement(child, {
          ...child.props,
        })
      }
    })}
  </S.Container>
)

DashboardMenu.Item = DashboardMenuItem
